import { render } from "./EarningsCalendar.vue?vue&type=template&id=2c9537e8&scoped=true"
import script from "./EarningsCalendar.vue?vue&type=script&lang=js"
export * from "./EarningsCalendar.vue?vue&type=script&lang=js"

import "./EarningsCalendar.vue?vue&type=style&index=0&id=2c9537e8&scoped=true&lang=scss"

import exportComponent from "/var/www/eztrade-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c9537e8"]])

export default __exports__